module.exports = __webpack_public_path__ + "img/付款关怀.c3722675.svg";